export const GAME_CONSTANTS = {
  // Map Sizes
  SP_WORLD_SIZE: 30,
  SP_ARENA_SIZE: 20,
  COOP_WORLD_SIZE: 60,
  COOP_ARENA_SIZE: 50,
  PVP_WORLD_WIDTH: 65,
  PVP_WORLD_HEIGHT: 120,
  PVP_ARENA_SIZE: 20,
  PVP_LANE_COUNT: 8,
  
  // Pathfinding
  MIN_DISTANCE: 12,  // Tiles for midpoint routing
  
  // HP
  PLAYER_BASE_HP: 100,
  
  // Economy
  KILL_GOLD_BASE: 3,
  KILL_GOLD_MAX: 12,
  KILL_GOLD_TIER_INTERVAL: 15,
  GPM_BASE: 5,
  GPM_MAX: 15,
  GPM_INCREASE_INTERVAL: 10,
  WAVE_BONUS_EARLY: 5,
  WAVE_BONUS_MID: 10,
  WAVE_BONUS_LATE: 15,
  EVENT_BONUS: 10,
  BOSS_BONUS: 75,
  GOLD_FREEZE_WAVE: 150,
  
  // Enemy Scaling
  ENEMY_HP_BASE: 30,
  ENEMY_HP_MULTIPLIER: 1.09,
  ENEMY_HP_SURVIVAL_MULTIPLIER: 1.12,
  ENEMY_COUNT_BASE: 8,
  ENEMY_COUNT_MULTIPLIER: 1.065,
  ENEMY_COUNT_SURVIVAL_MULTIPLIER: 1.09,
  
  // Waves
  TOTAL_WAVES: 100,
  BOSS_WAVE_INTERVAL: 10,
  MINIBOSS_WAVE_INTERVAL: 5,
  MINIBOSS_START_WAVE: 15,
  EVENT_WAVE_OFFSET: 2,  // 2 waves before boss
  
  // Boss Scaling
  BOSS_HP_MULTIPLIER: 30,
  BOSS_DAMAGE: 20,
  MINIBOSS_HP_MULTIPLIER: 10,
  MINIBOSS_DAMAGE: 10,
  
  // Upgrade Costs
  UPGRADE_A_PERCENT: 0.6,
  UPGRADE_B_MULTIPLIER: 1.6,
  
  // Tower Costs (from GDD Section 3)
  TOWER_COSTS: {
    arrow: 50,
    cannon: 75,
    sniper: 100,
    totem: 50,
    fire: 100,      // + totem cost
    ice: 150,       // + totem cost
    lightning: 250  // + totem cost
  },
  
  // Structure Costs
  WALL_COST: 10,
  
  // Structure HP
  TOWER_HP: 100,
  WALL_HP_BASE: 150,
  WALL_HP_UPGRADE_A: 150,
  WALL_HP_UPGRADE_B: 200
} as const;

